module.exports = __webpack_public_path__ + "static/media/cloud-sun-tear.88c0af28.svg";